<template>
  <div class="invite_link">
    <div class="link_box link_flex">
      <div class="link_warp">
        <div class="link_top link_flex">
          <h3 style="font-size: 16px; font-weight: bold;">{{`邀请${typeInfo}加入平台`}}</h3>
          <img src="@/assets/ceping2.png" alt="" style="cursor: pointer;" @click="closeHand">
        </div>
        <div class="link_foot">
          <p style="color: #303030;">{{`点击复制链接，发送至学校微信群，${typeInfo}点击链接即可加入`}}</p>
          <div class="foot_box link_flex">
            <div class="box_con">{{urlInfo}}</div>
            <a-button type="primary" @click="copyLink" class="tag">复制链接</a-button>
          </div>
          <span style="font-size: 12px; color: #F89348;">链接14天内有效，过期需重新生成邀请链接</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
import moment from 'moment'
import URL from '@/store/url'
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'InviteLink',
  props: ['info'],
  data () {
    return {
      typeInfo: null,
      urlInfo: null
    }
  },
  computed: {
    ...mapState([
      'teacherAdmin'
    ])
  },
  watch: {
    info () {
      const times = moment(new Date()).valueOf()
      const basicInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      this.typeInfo = this.info
      if (this.typeInfo === '班主任') {
        this.urlInfo = `${URL.TO_HEADMASTER}?teacherUid=${this.teacherAdmin.uid}&schoolId=${this.teacherAdmin.school_id}&token=${this.teacherAdmin.tokenValue}&schoolName=${encodeURIComponent(basicInfo.school_name)}&minGrade=${basicInfo.min_grade}&maxGrade=${basicInfo.max_grade}&isHeadMaster=headMaster&timeStamp=${times}&jwt=${JSON.parse(sessionStorage.getItem('teacherAdmin')).jwt}`
      } else {
        this.urlInfo = `${URL.TO_HEADMASTER}?teacherUid=${this.teacherAdmin.uid}&schoolId=${this.teacherAdmin.school_id}&token=${this.teacherAdmin.tokenValue}&schoolName=${encodeURIComponent(basicInfo.school_name)}&minGrade=${basicInfo.min_grade}&maxGrade=${basicInfo.max_grade}&isHeadMaster=nonheadMaster&timeStamp=${times}&jwt=${JSON.parse(sessionStorage.getItem('teacherAdmin')).jwt}`
      }
    }
  },
  methods: {
    ...mapMutations([
      'setCopyStatus'
    ]),
    copyLink () {
      let clipboard = new Clipboard('.tag', {
        text: () => {
          let info = this.urlInfo
          return info
        }
      })
      clipboard.on('success', e => {
        console.log(e)
        this.$message.success('链接复制成功')
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        console.log(e)
        this.$message.error('链接复制失败')
        clipboard.destroy()
      })
    },
    closeHand () {
      this.setCopyStatus(false)
    }
  }
}
</script>

<style>
.invite_link {
  position: fixed;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
  z-index: 1000;
  background-color: rgba(0, 0, 0, .4);
}
.invite_link .link_flex {
  display: flex;
}
.invite_link .link_box {
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
}
.invite_link .link_box .link_warp {
  width: 640px;
  border-radius: 4px;
  background-color: #FFFFFF;
}
.invite_link .link_box .link_warp .link_top {
  padding: 16px 24px;
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;
  border-bottom: 1px solid #EBEBEB;
}
.invite_link .link_box .link_warp .link_foot {
  padding: 30px 24px;
  box-sizing: border-box;
}
.invite_link .link_box .link_warp .link_foot .foot_box {
  align-items: center;
  justify-content: space-between;
}
.invite_link .link_box .link_warp .link_foot .foot_box .box_con {
  flex: 1;
  color: #BFBFBF;
  border: 1px solid #D9D9D9;
  background-color: #F5F5F5;
  padding: 8px 16px;
  border-radius: 4px;
  margin: 16px 16px 16px 0px;
  box-sizing: border-box;
  overflow: hidden;
  max-height: 36px;
  line-height: 24px;
}
.invite_link .link_box .link_warp /deep/ .ant-btn-primary {
  background-color: #51BF94;
  height: 36px;
}
.invite_link .link_box .link_warp /deep/ .ant-btn-primary:hover, .invite_link .link_box .link_warp /deep/ .ant-btn-primary:focus {
  color: #FFFFFF;
  background-color:rgba(81, 191, 148, .7);
}
</style>
